import {call, put, select} from "redux-saga/effects";
import {
  setLoading,
  setResult
} from "../../slices/dynamicElementsSlice";
import {getCarousel, getOnGoingCampaigns, getPromotionalEvents, getRemoteConfigs} from "../requests/dashboardService";
import {getBrandList, getBrandWeekList} from "../requests/brandService";

export function* handleGetCarousel() {
  try {
    yield put(setLoading({element: 'carousel', loading: true}));
    const {data} = yield call(() => getCarousel());
    const imageData = data?.reduce((acc, curr) => {
      if (curr.image) acc['mobile'].push(curr);
      if (curr.image_for_web) acc['web'].push(curr);
      return acc;
    }, {web: [], mobile: []});

    if (!imageData.web.length) {
      imageData.web = imageData.mobile;
    }

    if (!imageData.mobile.length) {
      imageData.mobile = imageData.web;
    }

    yield put(setResult({data: imageData, element: 'carousel'}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    // toast.error(`Error: ${errMsg}`);
    yield put(setResult({error: errMsg, element: 'carousel'}));
  }
}

export function* handleGetBrandWeekList(action) {
  const element = 'weeklyBrands';
  try {
    yield put(setLoading({element, loading: true}));
    const {data: response} = yield call(() => getBrandWeekList());
    yield put(setResult({data: response.data, element}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

export function* handleGetBrandList(action) {
  const element = action.payload.featured ? 'featuredBrands' : 'allBrands';
  try {
    yield put(setLoading({element, loading: true}));
    const state = yield select((state) => state.dynamicElements[element]);
    const {
      data: {
        page,
        has_next: hasNext,
        total_results: totalResults,
        data
      }
    } = yield call(() => getBrandList(state.page + 1, action.payload.featured));
    yield put(setResult({data, element, hasNext, page, totalResults}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

export function* handleGetRemoteConfigs(action) {
  const element = 'remoteConfigs';
  try {
    yield put(setLoading({element, loading: true}));

    const {data} = yield call(() => getRemoteConfigs());
    yield put(setResult({data: data.config, element}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

export function* handleGetCampaigns(action) {
  const element = 'campaigns';
  try {
    yield put(setLoading({element, loading: true}));

    const {data} = yield call(() => getOnGoingCampaigns());
    yield put(setResult({data, element}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

export function* handleGetPromotionalEvents(action) {
  const element = 'promotionalEvents';
  try {
    yield put(setLoading({element, loading: true}));

    const {data} = yield call(() => getPromotionalEvents());
    yield put(setResult({data, element}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

